import { Component } from '@angular/core';

@Component({
  selector: 'app-coatings',
  templateUrl: './coatings.component.html',
  styleUrls: ['./coatings.component.scss']
})
export class CoatingsComponent {

  coatinglist:any[] = [
    { 'item': 'TiN'},
    { 'item': 'DLC'},
    { 'item': 'DLC'},
    { 'item': 'TiCN'},
    { 'item': 'S-ACX'},
    { 'item': 'S-ACX'},
    { 'item': 'TiAlN'},
    { 'item': 'S-ACX'},
    { 'item': 'S-ACX'},
    { 'item': 'TiAlN'}
  ]

  advapp:any[] = [
    { 'item': '<h4>Anti-Wear</h4> <p>Cutting Tools, Molds, Auto Parts, Machine Parts</p>'},
    { 'item': '<h4>Anti-Corrosion</h4> <p>Resin Molds, Water parts</p>'},
    { 'item': '<h4>Sliding</h4> <p>Automobile Parts, Machine Parts, Electric Parts</p>'},
    { 'item': '<h4>Appearance</h4> <p>Watch, Glasses, Decorative Goods</p>'},
  ]

  tableData = {
    "thead": {
      "tr": [
        { "th": "" },
        { "th": "TN" },
        { "th": "TA" },
        { "th": "TC" },
        { "th": "CR" },
        { "th": "DC" },
        { "th": "ACX" },
        { "th": "SCA" },
        { "th": "ACY" },
        { "th": "TSX" }
      ]
    },
    "tbody": {
      "tr": [
        [
          { "td": "Film Material" },
          { "td": "TIN" },
          { "td": "TIN" },
          { "td": "TIN" },
          { "td": "TIN" },
          { "td": "TIN" },
          { "td": "TIN" },
          { "td": "TIN" },
          { "td": "TIN" },
          { "td": "TIN" }
        ],
        [
          { "td": "Thickness" },
          { "td": "2-5µm" },
          { "td": "2-5µm" },
          { "td": "2-5µm" },
          { "td": "2-5µm" },
          { "td": "2-5µm" },
          { "td": "2-5µm" },
          { "td": "2-5µm" },
          { "td": "2-5µm" },
          { "td": "2-5µm" }
        ],
        [
          { "td": "Hardness" },
          { "td": "Hv2000" },
          { "td": "Hv2000" },
          { "td": "Hv2000" },
          { "td": "Hv2000" },
          { "td": "Hv2000" },
          { "td": "Hv2000" },
          { "td": "Hv2000" },
          { "td": "Hv2000" },
          { "td": "Hv2000" }
        ],
        [
          { "td": "Max. Working Temperature" },
          { "td": "600º" },
          { "td": "600º" },
          { "td": "600º" },
          { "td": "600º" },
          { "td": "600º" },
          { "td": "600º" },
          { "td": "600º" },
          { "td": "600º" },
          { "td": "600º" }
        ],
        [
          { "td": "Color" },
          { "td": "Gold" },
          { "td": "Gold" },
          { "td": "Gold" },
          { "td": "Gold" },
          { "td": "Gold" },
          { "td": "Gold" },
          { "td": "Gold" },
          { "td": "Gold" },
          { "td": "Gold" }
        ]
        
      ]
    }
  };
  
}
